export const environment = {
    production: false,
    firebase: {
        apiKey: "AIzaSyB-FfViPSY-eVMABdz1d0mf7gnf31MWTYA",
        authDomain: "tripsys2.firebaseapp.com",
        databaseURL: "https://tripsys2.firebaseio.com",
        projectId: "tripsys2",
        storageBucket: "tripsys2.appspot.com",
        messagingSenderId: "822885993059"
      }
  };



// WEBPACK FOOTER //
// ./src/environments/environment.ts